import { createRouter, createWebHistory } from 'vue-router'
import TyreInfo from '@/components/TyreInfo.vue'
import VehicleWarranty from '@/components/VehicleWarranty.vue'
import TyreClaim from '@/components/TyreClaim.vue'
import TyreClaimReview from '@/components/TyreClaimReview.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: TyreInfo
  },
  {
    path: '/:uuid',
    name: 'TyreInfo',
    component: TyreInfo,
    props: true
  },
  {
    path: '/vehicle-warranty/:uuid',
    name: 'VehicleWarranty',
    component: VehicleWarranty
  },
  {
    path: '/tyre-claim',
    name: 'TyreClaim',
    component: TyreClaim,
    props: true
  },
  {
    path: '/tyre-claim-review/',
    name: 'TyreClaimReview',
    component: TyreClaimReview,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
